import type { ProviderTag } from '@sequesto-os/shared';

const TAG_LABELS: Record<ProviderTag, string> = {
  sales: 'Sales',
  marketing: 'Marketing',
  finance: 'Finance',
  content: 'Content',
  cs: 'CS',
};

/**
 * A row's secondary labels (provider, category, team tags) in the one tag style
 * the table uses: quiet grey text joined by middots. Pills are kept for status.
 */
export function RowTags({ labels, tags }: { labels?: (string | null | undefined)[]; tags?: readonly ProviderTag[] }) {
  const all = [...(labels ?? []), ...(tags ?? []).map((t) => TAG_LABELS[t])].filter(
    (l): l is string => typeof l === 'string' && l.length > 0
  );
  if (all.length === 0) return null;
  return <span className="text-body-xs text-text-tertiary">{all.join(' · ')}</span>;
}
